/** Fixed score colors for 1–10: green → yellow → orange → red (theme-independent). */
const RATING_SCORE_COLORS = {
  10: '#27ae60',
  9: '#6abf40',
  8: '#9acd32',
  7: '#f1c40f',
  6: '#f39c12',
  5: '#e67e22',
  4: '#e8834a',
  3: '#e74c3c',
  2: '#c0392b',
  1: '#a93226',
};

export function getRatingScoreColor(rating) {
  const score = Math.round(Number(rating));
  if (!Number.isFinite(score) || score < 1 || score > 10) {
    return '#94a3b8';
  }
  return RATING_SCORE_COLORS[score];
}
